import { Injectable, ApplicationRef, ComponentFactoryResolver, Injector, EmbeddedViewRef, ReflectiveInjector } from '@angular/core';
import { NotificationComponent } from '@components/notification/notification.component';

@Injectable()
export class ModalService {

  constructor(private app: ApplicationRef, private injector: Injector, private resolver: ComponentFactoryResolver) { }

  open(Component:any) {
    let factory = this.resolver.resolveComponentFactory(Component);

    const componentRef:any = this.resolver.resolveComponentFactory(Component).create(this.injector);

    // componentRef.instance.type = type;
    // componentRef.instance.message = message;
    componentRef.instance.componentRef = componentRef;

    this.app.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);

    return componentRef;
  }

  destroy(componentRef) {
    this.app.detachView(componentRef);
    componentRef.destroy();
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/modal/modal.service.ts